import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-789fb8dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl text-green-600 font-bold mt-6 text-center" }, "Officella bekräftat", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold text-center p-2" }, "Dag 1", -1))
const _hoisted_3 = { class: "table-fixed border w-full" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold text-center p-2" }, "Dag 2", -1))
const _hoisted_6 = { class: "table-fixed border w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-xl font-bold text-center p-2" }, "Dag 3", -1))
const _hoisted_9 = { class: "table-fixed border w-full" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventSelect = _resolveComponent("EventSelect")!
  const _component_RoundRow = _resolveComponent("RoundRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EventSelect, { onPlayerSelected: _ctx.main }, null, 8, ["onPlayerSelected"]),
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_4,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6, 7, 8, 9], (n) => {
            return _createElementVNode("th", { key: n }, _toDisplayString(n), 1)
          }), 64))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rounds1, (round) => {
        return (_openBlock(), _createBlock(_component_RoundRow, {
          key: round.id,
          round: round,
          events: _ctx.events
        }, null, 8, ["round", "events"]))
      }), 128))
    ]),
    _hoisted_5,
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_7,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6, 7, 8, 9], (n) => {
            return _createElementVNode("th", { key: n }, _toDisplayString(n), 1)
          }), 64))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rounds2, (round) => {
        return (_openBlock(), _createBlock(_component_RoundRow, {
          key: round.id,
          round: round,
          events: _ctx.events
        }, null, 8, ["round", "events"]))
      }), 128))
    ]),
    _hoisted_8,
    _createElementVNode("table", _hoisted_9, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_10,
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3, 4, 5, 6], (n) => {
            return _createElementVNode("th", { key: n }, _toDisplayString(n), 1)
          }), 64))
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rounds3, (round) => {
        return (_openBlock(), _createBlock(_component_RoundRow, {
          key: round.id,
          round: round,
          events: _ctx.events
        }, null, 8, ["round", "events"]))
      }), 128))
    ])
  ], 64))
}